import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  "data-name": "ikona WYKRZYKNIK"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" stroke=\"#f90d0d\" stroke-width=\"1.5\" data-name=\"Ellipse 311\"><circle cx=\"8\" cy=\"8\" r=\"8\" stroke=\"none\"></circle><circle cx=\"8\" cy=\"8\" r=\"7.25\"></circle></g><path fill=\"none\" stroke=\"#f90d0d\" stroke-width=\"1.5\" d=\"M8 3.192v5\" data-name=\"Path 16707\"></path><path fill=\"none\" stroke=\"#f90d0d\" stroke-width=\"1.5\" d=\"M8 9.862v2\" data-name=\"Path 16709\"></path>", 3)
  ]))]))
}
export default { render: render }